import type { GenericDetails } from 'components/Input/Autocomplete';

export const GENERATE_TOOLBAR_FIELDS = 'GENERATE_TOOLBAR_FIELDS';
export const SET_TOOLBAR_VALUE = 'SET_TOOLBAR_VALUE';

export type ToolbarState = Record<string, Record<string, GenericDetails | undefined> | undefined>;

export interface ToolbarAction {
    type: typeof GENERATE_TOOLBAR_FIELDS | typeof SET_TOOLBAR_VALUE;
    payload: Record<string, any>;
}
